import React from 'react';
import ComingSoon from './ComingSoon';
 import MyAddresss from '../AddressComplete/MyAddresss';

const ProfileAddress = () => {
   return <MyAddresss pageName="My Address" />;
  //return <ComingSoon pageName="My Address" />;
  
};

export default ProfileAddress;
